"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichContentMoney = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const RichContentMoney = ({ money, bold, italic, color, fontSize }) => {
    const displayValue = money.displayString || `${money.currencyCode} ${money.amount}`;
    return (react_1.default.createElement(styles_1.StyledSpan, { bold: bold, italic: italic, "data-cy": "money", color: color, font: fontSize }, displayValue));
};
exports.RichContentMoney = RichContentMoney;
